// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__yjRVO","insightsList":"newBusinessInsightsMenu_insightsList__2j6DY","active":"newBusinessInsightsMenu_active__23PYu"};